<template>
    <div class="grid grid-cols-1 md:grid-cols-4 gap-x-[40px] w-full text-[14px]">

        <div class="col-span-1 md:col-span-3">
            <RecentMentions v-if="props.data" :data="props.data" :prefixRoute="props.prefixRoute"></RecentMentions>
        </div>

        <div class="col-span-1 flex flex-col gap-[20px] md:gap-[40px]">

            <TopPlatforms :data="data" :total-mentions="props.data.totalMentions" :prefixRoute="prefixRoute"></TopPlatforms>

            <Chart :data="data" :prefixRoute="prefixRoute"></Chart>

            <div class="w-full">
                <ul class="flex flex-col divide-y divide-slate-200">
                    <li class="flex justify-between items-center py-[10px]">
                        <div>Total Mentions:</div> {{ props.data.totalMentions }}
                    </li>
                    <li class="flex justify-between items-center py-[10px]">
                        <div>New Mentions This Month:</div> {{ props.data.newMentionsThisMonth }}
                    </li>
                    <li class="flex justify-between items-center py-[10px]">
                        <div>Platforms Monitored:</div> {{ props.data.platforms.length }}
                    </li>
                    <li class="flex justify-between items-center py-[10px]">
                        <div>Average Mentions Per Day:</div> {{ props.data.avgMentionsPerDay }}
                    </li>
                    <li class="flex justify-between items-center py-[10px]">
                        <div>Highest Activity Day:</div> {{ props.data.highestActivityDay }}
                    </li>
                    <li class="flex justify-between items-center py-[10px]">
                        <div>Mention Growth Rate:</div> {{ props.data.mentionGrowth }}%
                    </li>
                    <li class="flex justify-between items-center py-[10px]">
                        <div>Top Performing Platform:</div> {{ props.data.topPlatform }}
                    </li>
                </ul>

            </div>

            <div class="w-full" v-if="0">
                <TitleBlockStat title="Most Mentioned Cases"></TitleBlockStat>

                <ul class="flex flex-col divide-y divide-slate-200">
                    <li v-for="caseItem in props.data.caseMentions" :key="caseItem.id" class="py-[10px] flex justify-between">
                        <strong>{{ caseItem.name }}</strong>
                        <span class="text-red-600">{{ caseItem.mentionsCount }} mentions</span>
                    </li>
                </ul>
            </div>
            
            <div class="w-full">
                <TitleBlockStat title="Top Keywords" info-text="all keywords" info-link="/admin"></TitleBlockStat>
                <ul class="flex flex-col divide-y divide-slate-200">
                    <li v-for="keyword in props.data.topKeywords" :key="keyword.id" class="py-[10px]">
                        <strong>{{ keyword.word }}</strong> - {{ keyword.mentions }} mentions
                    </li>
                </ul>
            </div>

            <div class="w-full">
                <TitleBlockStat title="Search queries" info-text="all queries"
                    :info-link="route(`${prefixRoute}.search-query.index`)"></TitleBlockStat>

                <ul class="flex flex-col divide-y divide-slate-200">
                    <li v-for="query in props.data.recentQueries" :key="query.id" class="py-[10px]">
                        {{ query.text }}
                    </li>
                </ul>

            </div>

        </div>

    </div>

    <pre v-if="0" class="mt-[500px] bg-red-500 text-white p-[20px]">{{ props.data.platforms }}</pre>

</template>

<script setup>
import { onMounted } from 'vue';
import TitleBlockStat from '@/Components/BrandMonitoring/TitleBlockStat.vue';
import TopPlatforms from '@/Components/BrandMonitoring/Widgets/TopPlatforms.vue';
import Chart from '@/Components/BrandMonitoring/Widgets/Chart.vue';
import RecentMentions from '@/Components/BrandMonitoring/Widgets/RecentMentions.vue';

const props = defineProps({
    data: Object,
    prefixRoute: String
});
</script>

<style>
hlword {
    font-weight: bold;
    background-color: #f8fafc;
    display: inline-block;
}
</style>